import o from "./SVGs/addToFolder.svg.mjs";
import r from "./SVGs/addedtoFolder.svg.mjs";
import t from "./SVGs/aiWand.svg.mjs";
import e from "./SVGs/alarmBell.svg.mjs";
import i from "./SVGs/alignBottom.svg.mjs";
import n from "./SVGs/alignCenter.svg.mjs";
import l from "./SVGs/alignLeft.svg.mjs";
import m from "./SVGs/alignMiddle.svg.mjs";
import a from "./SVGs/alignRight.svg.mjs";
import c from "./SVGs/alignTop.svg.mjs";
import s from "./SVGs/amex.svg.mjs";
import p from "./SVGs/applePay.svg.mjs";
import g from "./SVGs/arrowBack.svg.mjs";
import S from "./SVGs/arrowCursor_blue.svg.mjs";
import f from "./SVGs/arrowCursor_pink.svg.mjs";
import v from "./SVGs/arrowCursor_yellow.svg.mjs";
import u from "./SVGs/arrowDown.svg.mjs";
import d from "./SVGs/arrowRight.svg.mjs";
import w from "./SVGs/arrowUp.svg.mjs";
import k from "./SVGs/attachment.svg.mjs";
import P from "./SVGs/audioModified.svg.mjs";
import B from "./SVGs/blankCalendar_blue.svg.mjs";
import C from "./SVGs/blankCalendar_pink.svg.mjs";
import h from "./SVGs/blankCalendar_yellow.svg.mjs";
import Y from "./SVGs/brain.svg.mjs";
import y from "./SVGs/businessStartup_blue.svg.mjs";
import b from "./SVGs/businessStartup_pink.svg.mjs";
import A from "./SVGs/businessStartup_yellow.svg.mjs";
import M from "./SVGs/calendar.svg.mjs";
import I from "./SVGs/cameraVideo_blue.svg.mjs";
import L from "./SVGs/cameraVideo_pink.svg.mjs";
import V from "./SVGs/cameraVideo_yellow.svg.mjs";
import T from "./SVGs/camera_blue.svg.mjs";
import F from "./SVGs/camera_pink.svg.mjs";
import H from "./SVGs/camera_yellow.svg.mjs";
import G from "./SVGs/chatBubbleTypingOval_blue.svg.mjs";
import E from "./SVGs/chatBubbleTypingOval_pink.svg.mjs";
import U from "./SVGs/chatBubbleTypingOval_yellow.svg.mjs";
import W from "./SVGs/chatTwoBubblesSquare_blue.svg.mjs";
import D from "./SVGs/chatTwoBubblesSquare_pink.svg.mjs";
import O from "./SVGs/chatTwoBubblesSquare_yellow.svg.mjs";
import R from "./SVGs/check.svg.mjs";
import x from "./SVGs/checkCircle.svg.mjs";
import q from "./SVGs/chevronDown.svg.mjs";
import N from "./SVGs/chevronLeft.svg.mjs";
import K from "./SVGs/chevronRight.svg.mjs";
import z from "./SVGs/chevronUp.svg.mjs";
import Q from "./SVGs/circleCheck.svg.mjs";
import Z from "./SVGs/circleClock_black.svg.mjs";
import j from "./SVGs/circleClock_blue.svg.mjs";
import J from "./SVGs/circleClock_pink.svg.mjs";
import X from "./SVGs/circleClock_yellow.svg.mjs";
import _ from "./SVGs/close.svg.mjs";
import $ from "./SVGs/cog.svg.mjs";
import oo from "./SVGs/compass.svg.mjs";
import ro from "./SVGs/controlsForward.svg.mjs";
import to from "./SVGs/controlsPause.svg.mjs";
import eo from "./SVGs/controlsPlay.svg.mjs";
import io from "./SVGs/controlsRecord.svg.mjs";
import no from "./SVGs/controlsRewind.svg.mjs";
import lo from "./SVGs/controlsStop.svg.mjs";
import mo from "./SVGs/dashboardGauge_blue.svg.mjs";
import ao from "./SVGs/dashboardGauge_pink.svg.mjs";
import co from "./SVGs/dashboardGauge_yellow.svg.mjs";
import so from "./SVGs/dinersClub.svg.mjs";
import po from "./SVGs/discover.svg.mjs";
import go from "./SVGs/downloadBottom.svg.mjs";
import So from "./SVGs/downloadSquare_blue.svg.mjs";
import fo from "./SVGs/downloadSquare_pink.svg.mjs";
import vo from "./SVGs/downloadSquare_yellow.svg.mjs";
import uo from "./SVGs/dropbox.svg.mjs";
import wo from "./SVGs/emptyClipboard_blue.svg.mjs";
import ko from "./SVGs/emptyClipboard_pink.svg.mjs";
import Po from "./SVGs/emptyClipboard_yellow.svg.mjs";
import Bo from "./SVGs/erlenmeyerFlask_blue.svg.mjs";
import Co from "./SVGs/erlenmeyerFlask_pink.svg.mjs";
import ho from "./SVGs/erlenmeyerFlask_yellow.svg.mjs";
import Yo from "./SVGs/error.svg.mjs";
import yo from "./SVGs/expandHorizontal.svg.mjs";
import bo from "./SVGs/expandVertical.svg.mjs";
import Ao from "./SVGs/facebook.svg.mjs";
import Mo from "./SVGs/favorite.svg.mjs";
import Io from "./SVGs/favoriteFilled.svg.mjs";
import Lo from "./SVGs/fileDouble.svg.mjs";
import Vo from "./SVGs/filter.svg.mjs";
import To from "./SVGs/filterImage.svg.mjs";
import Fo from "./SVGs/filterMusic.svg.mjs";
import Ho from "./SVGs/filterPlus.svg.mjs";
import Go from "./SVGs/filterVideo.svg.mjs";
import Eo from "./SVGs/folderStar.svg.mjs";
import Uo from "./SVGs/generateImage.svg.mjs";
import Wo from "./SVGs/generateVideo.svg.mjs";
import Do from "./SVGs/gitHub.svg.mjs";
import Oo from "./SVGs/googlePay.svg.mjs";
import Ro from "./SVGs/graphPieChart_blue.svg.mjs";
import xo from "./SVGs/graphPieChart_pink.svg.mjs";
import qo from "./SVGs/graphPieChart_yellow.svg.mjs";
import No from "./SVGs/gridRules_blue.svg.mjs";
import Ko from "./SVGs/gridRules_pink.svg.mjs";
import zo from "./SVGs/gridRules_yellow.svg.mjs";
import Qo from "./SVGs/happyFace_blue.svg.mjs";
import Zo from "./SVGs/happyFace_pink.svg.mjs";
import jo from "./SVGs/happyFace_yellow.svg.mjs";
import Jo from "./SVGs/headphonesCustomer.svg.mjs";
import Xo from "./SVGs/helpChat_blue.svg.mjs";
import _o from "./SVGs/helpChat_pink.svg.mjs";
import $o from "./SVGs/helpChat_yellow.svg.mjs";
import or from "./SVGs/home_blue.svg.mjs";
import rr from "./SVGs/home_pink.svg.mjs";
import tr from "./SVGs/home_yellow.svg.mjs";
import er from "./SVGs/hourGlass_blue.svg.mjs";
import ir from "./SVGs/hourGlass_pink.svg.mjs";
import nr from "./SVGs/hourGlass_yellow.svg.mjs";
import lr from "./SVGs/house.svg.mjs";
import mr from "./SVGs/imageModified.svg.mjs";
import ar from "./SVGs/informationCircle.svg.mjs";
import cr from "./SVGs/informationCircleInverted.svg.mjs";
import sr from "./SVGs/instagram.svg.mjs";
import pr from "./SVGs/interfaceAlertAlarmBell_blue.svg.mjs";
import gr from "./SVGs/interfaceAlertAlarmBell_pink.svg.mjs";
import Sr from "./SVGs/interfaceAlertAlarmBell_yellow.svg.mjs";
import fr from "./SVGs/interfaceAwardTrophy_blue.svg.mjs";
import vr from "./SVGs/interfaceAwardTrophy_pink.svg.mjs";
import ur from "./SVGs/interfaceAwardTrophy_yellow.svg.mjs";
import dr from "./SVGs/interfaceCursorArrow_blue.svg.mjs";
import wr from "./SVGs/interfaceCursorArrow_pink.svg.mjs";
import kr from "./SVGs/interfaceCursorArrow_yellow.svg.mjs";
import Pr from "./SVGs/interfaceFavoriteLike_blue.svg.mjs";
import Br from "./SVGs/interfaceFavoriteLike_pink.svg.mjs";
import Cr from "./SVGs/interfaceFavoriteLike_yellow.svg.mjs";
import hr from "./SVGs/interfaceImageVideoAudioSubtitles_blue.svg.mjs";
import Yr from "./SVGs/interfaceImageVideoAudioSubtitles_pink.svg.mjs";
import yr from "./SVGs/interfaceImageVideoAudioSubtitles_yellow.svg.mjs";
import br from "./SVGs/interfaceLightingLightBulb_blue.svg.mjs";
import Ar from "./SVGs/interfaceLightingLightBulb_pink.svg.mjs";
import Mr from "./SVGs/interfaceLightingLightBulb_yellow.svg.mjs";
import Ir from "./SVGs/interfaceSearch_blue.svg.mjs";
import Lr from "./SVGs/interfaceSearch_pink.svg.mjs";
import Vr from "./SVGs/interfaceSearch_yellow.svg.mjs";
import Tr from "./SVGs/keyboardArrowRight.svg.mjs";
import Fr from "./SVGs/keyboard_blue.svg.mjs";
import Hr from "./SVGs/keyboard_pink.svg.mjs";
import Gr from "./SVGs/keyboard_yellow.svg.mjs";
import Er from "./SVGs/layers_blue.svg.mjs";
import Ur from "./SVGs/layers_pink.svg.mjs";
import Wr from "./SVGs/layers_yellow.svg.mjs";
import Dr from "./SVGs/layoutWindow_blue.svg.mjs";
import Or from "./SVGs/layoutWindow_pink.svg.mjs";
import Rr from "./SVGs/layoutWindow_yellow.svg.mjs";
import xr from "./SVGs/linkedIn.svg.mjs";
import qr from "./SVGs/loadingRing.svg.mjs";
import Nr from "./SVGs/lock.svg.mjs";
import Kr from "./SVGs/lockUnlock.svg.mjs";
import zr from "./SVGs/login_blue.svg.mjs";
import Qr from "./SVGs/login_pink.svg.mjs";
import Zr from "./SVGs/login_yellow.svg.mjs";
import jr from "./SVGs/logoStoryblocks.svg.mjs";
import Jr from "./SVGs/logoStoryblocksGray.svg.mjs";
import Xr from "./SVGs/logoStoryblocksWhite.svg.mjs";
import _r from "./SVGs/maestro.svg.mjs";
import $r from "./SVGs/magicWand_blue.svg.mjs";
import ot from "./SVGs/magicWand_pink.svg.mjs";
import rt from "./SVGs/magicWand_yellow.svg.mjs";
import tt from "./SVGs/maker.svg.mjs";
import et from "./SVGs/mastercard.svg.mjs";
import it from "./SVGs/meetingCamera.svg.mjs";
import nt from "./SVGs/megaphone_blue.svg.mjs";
import lt from "./SVGs/megaphone_pink.svg.mjs";
import mt from "./SVGs/megaphone_yellow.svg.mjs";
import at from "./SVGs/microphone.svg.mjs";
import ct from "./SVGs/microphoneOff.svg.mjs";
import st from "./SVGs/moneyCashBill_blue.svg.mjs";
import pt from "./SVGs/moneyCashBill_pink.svg.mjs";
import gt from "./SVGs/moneyCashBill_yellow.svg.mjs";
import St from "./SVGs/moneyWallet_blue.svg.mjs";
import ft from "./SVGs/moneyWallet_pink.svg.mjs";
import vt from "./SVGs/moneyWallet_yellow.svg.mjs";
import ut from "./SVGs/musicSound.svg.mjs";
import dt from "./SVGs/navigationMenuHorizontal.svg.mjs";
import wt from "./SVGs/navigationMenuVertical.svg.mjs";
import kt from "./SVGs/newStickyNote_blue.svg.mjs";
import Pt from "./SVGs/newStickyNote_pink.svg.mjs";
import Bt from "./SVGs/newStickyNote_yellow.svg.mjs";
import Ct from "./SVGs/oneFingerTap_blue.svg.mjs";
import ht from "./SVGs/oneFingerTap_pink.svg.mjs";
import Yt from "./SVGs/oneFingerTap_yellow.svg.mjs";
import yt from "./SVGs/openBook_blue.svg.mjs";
import bt from "./SVGs/openBook_pink.svg.mjs";
import At from "./SVGs/openBook_yellow.svg.mjs";
import Mt from "./SVGs/panelCollapse.svg.mjs";
import It from "./SVGs/panelExpand.svg.mjs";
import Lt from "./SVGs/paragraphLeftAlign.svg.mjs";
import Vt from "./SVGs/paragraphsCenterAlign.svg.mjs";
import Tt from "./SVGs/paragraphsRightAlign.svg.mjs";
import Ft from "./SVGs/payPal.svg.mjs";
import Ht from "./SVGs/pen_blue.svg.mjs";
import Gt from "./SVGs/pen_pink.svg.mjs";
import Et from "./SVGs/pen_yellow.svg.mjs";
import Ut from "./SVGs/pencil.svg.mjs";
import Wt from "./SVGs/picturesFolderMemories_blue.svg.mjs";
import Dt from "./SVGs/picturesFolderMemories_pink.svg.mjs";
import Ot from "./SVGs/picturesFolderMemories_yellow.svg.mjs";
import Rt from "./SVGs/pin_blue.svg.mjs";
import xt from "./SVGs/pin_pink.svg.mjs";
import qt from "./SVGs/pin_yellow.svg.mjs";
import Nt from "./SVGs/pinterest.svg.mjs";
import Kt from "./SVGs/playList_blue.svg.mjs";
import zt from "./SVGs/playList_pink.svg.mjs";
import Qt from "./SVGs/playList_yellow.svg.mjs";
import Zt from "./SVGs/playVideo.svg.mjs";
import jt from "./SVGs/plus.svg.mjs";
import Jt from "./SVGs/profileAvatar.svg.mjs";
import Xt from "./SVGs/questionmark.svg.mjs";
import _t from "./SVGs/refresh.svg.mjs";
import $t from "./SVGs/screenTv_blue.svg.mjs";
import oe from "./SVGs/screenTv_pink.svg.mjs";
import re from "./SVGs/screenTv_yellow.svg.mjs";
import te from "./SVGs/script_blue.svg.mjs";
import ee from "./SVGs/script_pink.svg.mjs";
import ie from "./SVGs/script_yellow.svg.mjs";
import ne from "./SVGs/search.svg.mjs";
import le from "./SVGs/searchSimilar.svg.mjs";
import me from "./SVGs/settingMenu.svg.mjs";
import ae from "./SVGs/share.svg.mjs";
import ce from "./SVGs/shoppingCart_blue.svg.mjs";
import se from "./SVGs/shoppingCart_pink.svg.mjs";
import pe from "./SVGs/shoppingCart_yellow.svg.mjs";
import ge from "./SVGs/snapchat.svg.mjs";
import Se from "./SVGs/sparkle.svg.mjs";
import fe from "./SVGs/sparkles.svg.mjs";
import ve from "./SVGs/stamp.svg.mjs";
import ue from "./SVGs/starFourSided.svg.mjs";
import de from "./SVGs/stopwatch_blue.svg.mjs";
import we from "./SVGs/stopwatch_pink.svg.mjs";
import ke from "./SVGs/stopwatch_yellow.svg.mjs";
import Pe from "./SVGs/stripe.svg.mjs";
import Be from "./SVGs/sunCloud_blue.svg.mjs";
import Ce from "./SVGs/sunCloud_pink.svg.mjs";
import he from "./SVGs/sunCloud_yellow.svg.mjs";
import Ye from "./SVGs/textBold.svg.mjs";
import ye from "./SVGs/textInputArea.svg.mjs";
import be from "./SVGs/textItalic.svg.mjs";
import Ae from "./SVGs/textStrikeThrough.svg.mjs";
import Me from "./SVGs/textStyle.svg.mjs";
import Ie from "./SVGs/textUnderline.svg.mjs";
import Le from "./SVGs/thirdEye.svg.mjs";
import Ve from "./SVGs/thumbDown.svg.mjs";
import Te from "./SVGs/thumbUp.svg.mjs";
import Fe from "./SVGs/trash.svg.mjs";
import He from "./SVGs/travelMapEarth_blue.svg.mjs";
import Ge from "./SVGs/travelMapEarth_pink.svg.mjs";
import Ee from "./SVGs/travelMapEarth_yellow.svg.mjs";
import Ue from "./SVGs/twitter.svg.mjs";
import We from "./SVGs/uploadBottom.svg.mjs";
import De from "./SVGs/uploadCircle_blue.svg.mjs";
import Oe from "./SVGs/uploadCircle_pink.svg.mjs";
import Re from "./SVGs/uploadCircle_yellow.svg.mjs";
import xe from "./SVGs/userCircleSingle_blue.svg.mjs";
import qe from "./SVGs/userCircleSingle_pink.svg.mjs";
import Ne from "./SVGs/userCircleSingle_yellow.svg.mjs";
import Ke from "./SVGs/userSingle_blue.svg.mjs";
import ze from "./SVGs/userSingle_pink.svg.mjs";
import Qe from "./SVGs/userSingle_yellow.svg.mjs";
import Ze from "./SVGs/venmo.svg.mjs";
import je from "./SVGs/verticalSliderSquare_blue.svg.mjs";
import Je from "./SVGs/verticalSliderSquare_pink.svg.mjs";
import Xe from "./SVGs/verticalSliderSquare_yellow.svg.mjs";
import _e from "./SVGs/videoEditPeel.svg.mjs";
import $e from "./SVGs/videoEditSplit.svg.mjs";
import oi from "./SVGs/videoModified.svg.mjs";
import ri from "./SVGs/view.svg.mjs";
import ti from "./SVGs/viewOff.svg.mjs";
import ei from "./SVGs/visa.svg.mjs";
import ii from "./SVGs/voiceMail_blue.svg.mjs";
import ni from "./SVGs/voiceMail_pink.svg.mjs";
import li from "./SVGs/voiceMail_yellow.svg.mjs";
import mi from "./SVGs/volumeDown.svg.mjs";
import ai from "./SVGs/volumeLevelHigh_blue.svg.mjs";
import ci from "./SVGs/volumeLevelHigh_pink.svg.mjs";
import si from "./SVGs/volumeLevelHigh_yellow.svg.mjs";
import pi from "./SVGs/volumeMedium.svg.mjs";
import gi from "./SVGs/volumeOff.svg.mjs";
import Si from "./SVGs/volumeUp.svg.mjs";
import fi from "./SVGs/warningTriangle.svg.mjs";
import vi from "./SVGs/waveform.svg.mjs";
import ui from "./SVGs/webcamVideo_blue.svg.mjs";
import di from "./SVGs/webcamVideo_pink.svg.mjs";
import wi from "./SVGs/webcamVideo_yellow.svg.mjs";
import ki from "./SVGs/youtube.svg.mjs";
import Pi from "./SVGs/zap.svg.mjs";
const xc = o, qc = r, Nc = t, Kc = e, zc = i, Qc = n, Zc = l, jc = m, Jc = a, Xc = c, _c = s, $c = p, os = g, rs = S, ts = f, es = v, is = u, ns = d, ls = w, ms = k, as = P, cs = B, ss = C, ps = h, gs = Y, Ss = y, fs = b, vs = A, us = M, ds = T, ws = F, ks = H, Ps = I, Bs = L, Cs = V, hs = G, Ys = E, ys = U, bs = W, As = D, Ms = O, Is = R, Ls = x, Vs = q, Ts = N, Fs = K, Hs = z, Gs = Q, Es = Z, Us = j, Ws = J, Ds = X, Os = _, Rs = $, xs = oo, qs = ro, Ns = to, Ks = eo, zs = io, Qs = no, Zs = lo, js = mo, Js = ao, Xs = co, _s = so, $s = po, op = go, rp = So, tp = fo, ep = vo, ip = uo, np = wo, lp = ko, mp = Po, ap = Bo, cp = Co, sp = ho, pp = Yo, gp = yo, Sp = bo, fp = Ao, vp = Mo, up = Io, dp = Lo, wp = Vo, kp = To, Pp = Fo, Bp = Ho, Cp = Go, hp = Eo, Yp = Uo, yp = Wo, bp = Do, Ap = Oo, Mp = Ro, Ip = xo, Lp = qo, Vp = No, Tp = Ko, Fp = zo, Hp = Qo, Gp = Zo, Ep = jo, Up = Jo, Wp = Xo, Dp = _o, Op = $o, Rp = or, xp = rr, qp = tr, Np = er, Kp = ir, zp = nr, Qp = lr, Zp = mr, jp = ar, Jp = cr, Xp = sr, _p = pr, $p = gr, og = Sr, rg = fr, tg = vr, eg = ur, ig = dr, ng = wr, lg = kr, mg = Pr, ag = Br, cg = Cr, sg = hr, pg = Yr, gg = yr, Sg = br, fg = Ar, vg = Mr, ug = Ir, dg = Lr, wg = Vr, kg = Fr, Pg = Hr, Bg = Gr, Cg = Tr, hg = Er, Yg = Ur, yg = Wr, bg = Dr, Ag = Or, Mg = Rr, Ig = xr, Lg = qr, Vg = Nr, Tg = Kr, Fg = zr, Hg = Qr, Gg = Zr, Eg = jr, Ug = Jr, Wg = Xr, Dg = _r, Og = $r, Rg = ot, xg = rt, qg = tt, Ng = et, Kg = it, zg = nt, Qg = lt, Zg = mt, jg = at, Jg = ct, Xg = st, _g = pt, $g = gt, oS = St, rS = ft, tS = vt, eS = ut, iS = dt, nS = wt, lS = kt, mS = Pt, aS = Bt, cS = Ct, sS = ht, pS = Yt, gS = yt, SS = bt, fS = At, vS = Mt, uS = It, dS = Lt, wS = Vt, kS = Tt, PS = Ft, BS = Ht, CS = Gt, hS = Et, YS = Ut, yS = Wt, bS = Dt, AS = Ot, MS = Rt, IS = xt, LS = qt, VS = Nt, TS = Kt, FS = zt, HS = Qt, GS = Zt, ES = jt, US = Jt, WS = Xt, DS = _t, OS = $t, RS = oe, xS = re, qS = te, NS = ee, KS = ie, zS = ne, QS = le, ZS = me, jS = ae, JS = ce, XS = se, _S = pe, $S = ge, of = Se, rf = fe, tf = ve, ef = ue, nf = de, lf = we, mf = ke, af = Pe, cf = Be, sf = Ce, pf = he, gf = Ye, Sf = ye, ff = be, vf = Ae, uf = Me, df = Ie, wf = Le, kf = Ve, Pf = Te, Bf = Fe, Cf = He, hf = Ge, Yf = Ee, yf = Ue, bf = We, Af = De, Mf = Oe, If = Re, Lf = xe, Vf = qe, Tf = Ne, Ff = Ke, Hf = ze, Gf = Qe, Ef = Ze, Uf = je, Wf = Je, Df = Xe, Of = _e, Rf = $e, xf = oi, qf = ri, Nf = ti, Kf = ei, zf = ii, Qf = ni, Zf = li, jf = mi, Jf = ai, Xf = ci, _f = si, $f = pi, ov = gi, rv = Si, tv = fi, ev = vi, iv = ui, nv = di, lv = wi, mv = ki, av = Pi;
export {
  xc as AddToFolder,
  qc as AddedtoFolder,
  Nc as AiWand,
  Kc as AlarmBell,
  zc as AlignBottom,
  Qc as AlignCenter,
  Zc as AlignLeft,
  jc as AlignMiddle,
  Jc as AlignRight,
  Xc as AlignTop,
  _c as Amex,
  $c as ApplePay,
  os as ArrowBack,
  rs as ArrowCursorBlue,
  ts as ArrowCursorPink,
  es as ArrowCursorYellow,
  is as ArrowDown,
  ns as ArrowRight,
  ls as ArrowUp,
  ms as Attachment,
  as as AudioModified,
  cs as BlankCalendarBlue,
  ss as BlankCalendarPink,
  ps as BlankCalendarYellow,
  gs as Brain,
  Ss as BusinessStartupBlue,
  fs as BusinessStartupPink,
  vs as BusinessStartupYellow,
  us as Calendar,
  ds as CameraBlue,
  ws as CameraPink,
  Ps as CameraVideoBlue,
  Bs as CameraVideoPink,
  Cs as CameraVideoYellow,
  ks as CameraYellow,
  hs as ChatBubbleTypingOvalBlue,
  Ys as ChatBubbleTypingOvalPink,
  ys as ChatBubbleTypingOvalYellow,
  bs as ChatTwoBubblesSquareBlue,
  As as ChatTwoBubblesSquarePink,
  Ms as ChatTwoBubblesSquareYellow,
  Is as Check,
  Ls as CheckCircle,
  Vs as ChevronDown,
  Ts as ChevronLeft,
  Fs as ChevronRight,
  Hs as ChevronUp,
  Gs as CircleCheck,
  Es as CircleClockBlack,
  Us as CircleClockBlue,
  Ws as CircleClockPink,
  Ds as CircleClockYellow,
  Os as Close,
  Rs as Cog,
  xs as Compass,
  qs as ControlsForward,
  Ns as ControlsPause,
  Ks as ControlsPlay,
  zs as ControlsRecord,
  Qs as ControlsRewind,
  Zs as ControlsStop,
  js as DashboardGaugeBlue,
  Js as DashboardGaugePink,
  Xs as DashboardGaugeYellow,
  _s as DinersClub,
  $s as Discover,
  op as DownloadBottom,
  rp as DownloadSquareBlue,
  tp as DownloadSquarePink,
  ep as DownloadSquareYellow,
  ip as Dropbox,
  np as EmptyClipboardBlue,
  lp as EmptyClipboardPink,
  mp as EmptyClipboardYellow,
  ap as ErlenmeyerFlaskBlue,
  cp as ErlenmeyerFlaskPink,
  sp as ErlenmeyerFlaskYellow,
  pp as Error,
  gp as ExpandHorizontal,
  Sp as ExpandVertical,
  fp as Facebook,
  vp as Favorite,
  up as FavoriteFilled,
  dp as FileDouble,
  wp as Filter,
  kp as FilterImage,
  Pp as FilterMusic,
  Bp as FilterPlus,
  Cp as FilterVideo,
  hp as FolderStar,
  Yp as GenerateImage,
  yp as GenerateVideo,
  bp as GitHub,
  Ap as GooglePay,
  Mp as GraphPieChartBlue,
  Ip as GraphPieChartPink,
  Lp as GraphPieChartYellow,
  Vp as GridRulesBlue,
  Tp as GridRulesPink,
  Fp as GridRulesYellow,
  Hp as HappyFaceBlue,
  Gp as HappyFacePink,
  Ep as HappyFaceYellow,
  Up as HeadphonesCustomer,
  Wp as HelpChatBlue,
  Dp as HelpChatPink,
  Op as HelpChatYellow,
  Rp as HomeBlue,
  xp as HomePink,
  qp as HomeYellow,
  Np as HourGlassBlue,
  Kp as HourGlassPink,
  zp as HourGlassYellow,
  Qp as House,
  Zp as ImageModified,
  jp as InformationCircle,
  Jp as InformationCircleInverted,
  Xp as Instagram,
  _p as InterfaceAlertAlarmBellBlue,
  $p as InterfaceAlertAlarmBellPink,
  og as InterfaceAlertAlarmBellYellow,
  rg as InterfaceAwardTrophyBlue,
  tg as InterfaceAwardTrophyPink,
  eg as InterfaceAwardTrophyYellow,
  ig as InterfaceCursorArrowBlue,
  ng as InterfaceCursorArrowPink,
  lg as InterfaceCursorArrowYellow,
  mg as InterfaceFavoriteLikeBlue,
  ag as InterfaceFavoriteLikePink,
  cg as InterfaceFavoriteLikeYellow,
  sg as InterfaceImageVideoAudioSubtitlesBlue,
  pg as InterfaceImageVideoAudioSubtitlesPink,
  gg as InterfaceImageVideoAudioSubtitlesYellow,
  Sg as InterfaceLightingLightBulbBlue,
  fg as InterfaceLightingLightBulbPink,
  vg as InterfaceLightingLightBulbYellow,
  ug as InterfaceSearchBlue,
  dg as InterfaceSearchPink,
  wg as InterfaceSearchYellow,
  Cg as KeyboardArrowRight,
  kg as KeyboardBlue,
  Pg as KeyboardPink,
  Bg as KeyboardYellow,
  hg as LayersBlue,
  Yg as LayersPink,
  yg as LayersYellow,
  bg as LayoutWindowBlue,
  Ag as LayoutWindowPink,
  Mg as LayoutWindowYellow,
  Ig as LinkedIn,
  Lg as LoadingRing,
  Vg as Lock,
  Tg as LockUnlock,
  Fg as LoginBlue,
  Hg as LoginPink,
  Gg as LoginYellow,
  Eg as LogoStoryblocks,
  Ug as LogoStoryblocksGray,
  Wg as LogoStoryblocksWhite,
  Dg as Maestro,
  Og as MagicWandBlue,
  Rg as MagicWandPink,
  xg as MagicWandYellow,
  qg as Maker,
  Ng as Mastercard,
  Kg as MeetingCamera,
  zg as MegaphoneBlue,
  Qg as MegaphonePink,
  Zg as MegaphoneYellow,
  jg as Microphone,
  Jg as MicrophoneOff,
  Xg as MoneyCashBillBlue,
  _g as MoneyCashBillPink,
  $g as MoneyCashBillYellow,
  oS as MoneyWalletBlue,
  rS as MoneyWalletPink,
  tS as MoneyWalletYellow,
  eS as MusicSound,
  iS as NavigationMenuHorizontal,
  nS as NavigationMenuVertical,
  lS as NewStickyNoteBlue,
  mS as NewStickyNotePink,
  aS as NewStickyNoteYellow,
  cS as OneFingerTapBlue,
  sS as OneFingerTapPink,
  pS as OneFingerTapYellow,
  gS as OpenBookBlue,
  SS as OpenBookPink,
  fS as OpenBookYellow,
  vS as PanelCollapse,
  uS as PanelExpand,
  dS as ParagraphLeftAlign,
  wS as ParagraphsCenterAlign,
  kS as ParagraphsRightAlign,
  PS as PayPal,
  BS as PenBlue,
  CS as PenPink,
  hS as PenYellow,
  YS as Pencil,
  yS as PicturesFolderMemoriesBlue,
  bS as PicturesFolderMemoriesPink,
  AS as PicturesFolderMemoriesYellow,
  MS as PinBlue,
  IS as PinPink,
  LS as PinYellow,
  VS as Pinterest,
  TS as PlayListBlue,
  FS as PlayListPink,
  HS as PlayListYellow,
  GS as PlayVideo,
  ES as Plus,
  US as ProfileAvatar,
  WS as Questionmark,
  DS as Refresh,
  OS as ScreenTvBlue,
  RS as ScreenTvPink,
  xS as ScreenTvYellow,
  qS as ScriptBlue,
  NS as ScriptPink,
  KS as ScriptYellow,
  zS as Search,
  QS as SearchSimilar,
  ZS as SettingMenu,
  jS as Share,
  JS as ShoppingCartBlue,
  XS as ShoppingCartPink,
  _S as ShoppingCartYellow,
  $S as Snapchat,
  of as Sparkle,
  rf as Sparkles,
  tf as Stamp,
  ef as StarFourSided,
  nf as StopwatchBlue,
  lf as StopwatchPink,
  mf as StopwatchYellow,
  af as Stripe,
  cf as SunCloudBlue,
  sf as SunCloudPink,
  pf as SunCloudYellow,
  gf as TextBold,
  Sf as TextInputArea,
  ff as TextItalic,
  vf as TextStrikeThrough,
  uf as TextStyle,
  df as TextUnderline,
  wf as ThirdEye,
  kf as ThumbDown,
  Pf as ThumbUp,
  Bf as Trash,
  Cf as TravelMapEarthBlue,
  hf as TravelMapEarthPink,
  Yf as TravelMapEarthYellow,
  yf as Twitter,
  bf as UploadBottom,
  Af as UploadCircleBlue,
  Mf as UploadCirclePink,
  If as UploadCircleYellow,
  Lf as UserCircleSingleBlue,
  Vf as UserCircleSinglePink,
  Tf as UserCircleSingleYellow,
  Ff as UserSingleBlue,
  Hf as UserSinglePink,
  Gf as UserSingleYellow,
  Ef as Venmo,
  Uf as VerticalSliderSquareBlue,
  Wf as VerticalSliderSquarePink,
  Df as VerticalSliderSquareYellow,
  Of as VideoEditPeel,
  Rf as VideoEditSplit,
  xf as VideoModified,
  qf as View,
  Nf as ViewOff,
  Kf as Visa,
  zf as VoiceMailBlue,
  Qf as VoiceMailPink,
  Zf as VoiceMailYellow,
  jf as VolumeDown,
  Jf as VolumeLevelHighBlue,
  Xf as VolumeLevelHighPink,
  _f as VolumeLevelHighYellow,
  $f as VolumeMedium,
  ov as VolumeOff,
  rv as VolumeUp,
  tv as WarningTriangle,
  ev as Waveform,
  iv as WebcamVideoBlue,
  nv as WebcamVideoPink,
  lv as WebcamVideoYellow,
  mv as Youtube,
  av as Zap
};
